import { render, staticRenderFns } from "./gestraald-glas.vue?vue&type=template&id=3a62d2b3&scoped=true"
import script from "./gestraald-glas.vue?vue&type=script&lang=js"
export * from "./gestraald-glas.vue?vue&type=script&lang=js"
import style0 from "./gestraald-glas.vue?vue&type=style&index=0&id=3a62d2b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a62d2b3",
  null
  
)

export default component.exports